
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M13 5H3a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2ZM13 9H3a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2ZM9 13H3a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  